<template>
  <div class="bg-gradient-primary main__wrapper">
    <notifications></notifications>
    <section class="section__wrapper">
      <div class="section__head">
        <div class="section__logo">
          <img
            class="logo"
            :src="require('@/assets/images/logo/stechoq-logo.svg')"
          />
        </div>
        <div class="section__header">
          <h1 class="heading">
            Welcome to
            <br />Stechoq Management Portal
          </h1>
        </div>
        <div class="wrapper-image-route">
          <a v-for="item in listPortal" :key="item.name" @click="handleRoute(item.href)">
            <img :src="item.image" :alt="item.name">
          </a>
        </div>
      </div>
      <button class="button__logout" @click="handleLogout">Log Out</button>
    </section>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "Portal",
  data() {
    return {
      listPortal: [
        { name: "HTOP", href: "https://htop.stechoq.com/auth/login", image :require('@/assets/images/icons/menu/work.svg') },
        { name: "E-Finance", href: "https://finance.htop.stechoq.com/", image :require('@/assets/images/icons/menu/finance.svg') },
      ],
    };
  },
  methods: {
    ...mapActions("auth", ["callLogout"]),
    ...mapActions("user", ["callUserInfo"]),
    notifyVue(type = "default", message) {
      this.$notify({
        message,
        timeout: 3000,
        icon: "ni ni-bell-55",
        type,
      });
    },
    async getUserInfo() {
      await this.callUserInfo();
    },
    handleRoute(href) {
      window.location.href = href;
    },
    async handleLogout() {
      try {
        await this.callLogout();
        this.$router.replace({ name: "Login" });
      } catch (error) {
        this.notifyVue("danger", "Logout failed, try again!");
      }
    },
  },
  mounted() {
    this.getUserInfo();
  },
};
</script>
<style lang="scss" scoped>
@mixin respond-lg {
  @media (min-width: 1024px) {
    @content;
  }
}
.main__wrapper {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  @include respond-lg {
    padding: 2.5% 0;
  }
}
.section__wrapper {
  background-color: #fff;
  padding: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  @include respond-lg {
    width: 360px;
    border-radius: 10px;
  }

  .section__logo {
    display: flex;
    justify-content: center;
    .logo {
      width: 70%;
    }
  }
  .section__header {
    margin-top: 20px;
    .heading {
      font-size: 1.1rem;
      font-weight: 700;
      text-align: center;
      color: #222f3e;
      @include respond-lg {
        font-size: 1.2rem;
      }
    }
  }
  .button__logout {
    margin-top: 10px;
    background-color: #ca301f;
    border: 1px solid #222f3e;
    padding: 15px 20px;
    border-radius: 10px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #fff;
    width: 100%;
    &:hover {
      background-color: #dd2f1b;
      transform: scale(1.05);
    }
  }
}
.wrapper-image-route {
  margin-top: 30px;
  width: 100%;
  a {
    width: 100%;
    img {
      cursor: pointer;
      object-position: center;
      width: 98%;
      @media only screen and (min-width: 480px) {
        width: 100%;
      }
    }
    img:first-child {
      margin-bottom: 30px;
    }
  }
}
</style>
